export default __webpack_public_path__ + "static/abouthero-sm-feef66dbe1b53c43bda5146d98c6c60a.jpg";